// FaqMini — acordeón de preguntas rápidas (usa <details>/<summary> nativo).
// Fuente: maquetas (kit-detalle, vecinos, como-funciona). Opcional link a la FAQ completa.
//
// Self-contained: <style>{FAQ_CSS}</style> + clases .tv5-faq-* + tokens --tv5-* propios.
// El "+" rota a "×" al abrir. Hover guard en el summary.
//
// Props:
//   items         Array<{q: string, a: ReactNode}>  → preguntas y respuestas
//   verTodasHref  string   → link "Ver todas las preguntas →" (opcional)
import { Link } from 'react-router-dom';

const FAQ_CSS = `
.tv5-faq {
  --tv5-teal:#00A8B5; --tv5-text:#F8F6F1; --tv5-muted:rgba(248,246,241,0.65);
  --tv5-border:rgba(255,255,255,0.08); --tv5-card:rgba(255,255,255,0.04);
  display:grid; gap:8px; max-width:720px; margin:0 auto;
  font-family:'Inter',-apple-system,BlinkMacSystemFont,sans-serif;
}
.tv5-faq details { background:var(--tv5-card); border:1px solid var(--tv5-border); border-radius:14px; overflow:hidden; transition:border-color 0.2s; }
.tv5-faq details[open] { background:rgba(0,168,181,0.06); border-color:rgba(0,168,181,0.25); }
.tv5-faq summary { padding:16px 20px; font-size:15px; font-weight:700; color:var(--tv5-text);
  cursor:pointer; list-style:none; display:flex; justify-content:space-between; align-items:center; gap:12px; }
.tv5-faq summary::-webkit-details-marker { display:none; }
.tv5-faq summary::after { content:'+'; font-size:20px; color:var(--tv5-teal); font-weight:300; flex-shrink:0; transition:transform 0.2s; }
.tv5-faq details[open] summary::after { transform:rotate(45deg); }
.tv5-faq-a { padding:0 20px 18px; font-size:14px; color:var(--tv5-muted); line-height:1.55; }
.tv5-faq-a a { color:var(--tv5-teal); text-decoration:none; font-weight:600; }
.tv5-faq-todas { display:block; text-align:center; margin-top:20px; color:var(--tv5-teal); font-weight:700; font-size:14px; text-decoration:none; }
@media (hover:hover){
  .tv5-faq summary:hover { color:var(--tv5-teal); }
  .tv5-faq-todas:hover { text-decoration:underline; }
}
`;

export function FaqMini({ items = [], verTodasHref }) {
  return (
    <div className="tv5-faq">
      <style>{FAQ_CSS}</style>
      {items.map((it, i) => (
        <details key={i}>
          <summary>{it.q}</summary>
          <div className="tv5-faq-a">{it.a}</div>
        </details>
      ))}
      {verTodasHref && <Link to={verTodasHref} className="tv5-faq-todas">Ver todas las preguntas →</Link>}
    </div>
  );
}
